import $ from "jquery";
import Cookies from "js-cookie";
import { Loader } from '@googlemaps/js-api-loader';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gmapSize from "./gmapStyle";
gsap.registerPlugin(ScrollTrigger);
const axios = require('axios').default;
import { getCityBySlug, getCityByCoords } from '../Utils/Locate';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Driver from 'driver.js';
let popupIsOpened = false;
let directCoords = null;
let geolocMarker;
let googleMapObject;
let cities;
let driver;
let language;
function showCityJump(err = null) {
    $("#mapholder").addClass("show-quick-jump");
    if (err != null) {
        $("#mapholder").addClass(err);
    }
}
function createPopup(category, item) {
    let popup = $(`
        <div class="map-popup scheme-${category.slug}" style="display: none"><div>
            <div class="picture" style="background-image: url(${item.poster})">
                <a href="#close" class="close-popup">
                    <svg xmlns="http://www.w3.org/2000/svg" width="9.124" height="9.121" viewBox="0 0 9.124 9.121">
                        <path d="M16.928,15.849l3.259-3.259a.764.764,0,0,0-1.08-1.08l-3.259,3.259L12.59,11.511a.764.764,0,1,0-1.08,1.08l3.259,3.259L11.51,19.108a.764.764,0,0,0,1.08,1.08l3.259-3.259,3.259,3.259a.764.764,0,1,0,1.08-1.08Z" transform="translate(-11.285 -11.289)" fill="#fff"/>
                    </svg>                                          
                </a>
            </div>
            <div class="content">
                <div>
                    <h2><a href="${item.link}" class='link'>${item.name}</a></h2>
                    <div class="address with-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22.455" height="27" viewBox="0 0 22.455 27">
                            <g transform="translate(-3.5 -0.5)">
                                <path class="pointer" d="M24.955,11.727c0,7.955-10.227,14.773-10.227,14.773S4.5,19.682,4.5,11.727a10.227,10.227,0,0,1,20.455,0Z" transform="translate(0 0)" fill="none" stroke="#80de86" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <path class="pointer" d="M19.611,13.555A3.055,3.055,0,1,1,16.555,10.5,3.055,3.055,0,0,1,19.611,13.555Z" transform="translate(-1.828 -1.917)" fill="none" stroke="#80de86" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                            </g>
                        </svg>
                        <span>${item.address}</span>
                    </div>
                </div>
            </div>
        </div></div>
    `);
    popup.insertAfter(".places-controller").fadeIn(200);
    popupIsOpened = true;
}
function askGeolocation(map, force = false) {
    if (directCoords == null) {
        if (navigator.geolocation) {
            geolocMarker.setMap(null);
            navigator.geolocation.getCurrentPosition((position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                map.setCenter(pos);
                let currentCity = (getCityByCoords(cities, pos.lat, pos.lng));
                if (currentCity != null) {
                    Cookies.set("currentCity", currentCity.slug);
                    let coords = new googleMapObject.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    geolocMarker.setPosition(coords);
                    geolocMarker.setMap(map);
                    if (Cookies.get("diver") == null)
                        driver.start();
                }
                else {
                    showCityJump("away");
                }
            }, (err) => {
                showCityJump("error");
            }, {
                enableHighAccuracy: true,
            });
        }
        else {
            showCityJump("away");
        }
    }
}
const mapPage = () => {
    const apiKey = $("#map").attr("data-uid");
    if ($("#mapholder").attr("data-lng") !== void 0) {
        directCoords = {
            lat: parseFloat($("#mapholder").attr("data-lat")),
            lng: parseFloat($("#mapholder").attr("data-lng")),
        };
    }
    const loader = new Loader({
        apiKey: apiKey,
        version: "weekly",
        libraries: []
    });
    const mapOptions = {
        center: {
            lat: 50.60655068312759,
            lng: 3.3888982997972716
        },
        zoom: 15,
        minZoom: 12,
        maxZoom: 18,
        mapTypeControl: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        gestureHandling: "cooperative",
    };
    let type = null;
    if ($("#mapholder").attr("data-type") !== void 0) {
        type = $("#mapholder").attr("data-type");
    }
    let map;
    loader
        .load()
        .then((google) => {
        googleMapObject = google;
        let styledMapType = new google.maps.StyledMapType(gmapSize);
        map = new google.maps.Map(document.getElementById("map"), mapOptions);
        map.mapTypes.set("styled_map", styledMapType);
        map.setMapTypeId("styled_map");
        geolocMarker = new google.maps.Marker({
            title: "My position",
            icon: "/app/themes/lumber/static/gfx/geoloc.svg"
        });
        let formData = new FormData();
        formData.append("locale", $("#mapholder").attr("data-locale"));
        axios.post("/api/cities", formData).then(function (response) {
            // handle success
            if (response.status == 200 && response.data.success == true) {
                cities = response.data.cities;
                let monuments = [];
                let scale = 2;
                $.each(cities, (k, v) => {
                    $.each(v.monuments, (key, monument) => {
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(monument.lat, monument.lng),
                            map: map,
                            zIndex: 50,
                            icon: {
                                url: monument.illustration,
                                size: new google.maps.Size(160 * scale, 160 * scale),
                                scaledSize: new google.maps.Size(20 * scale, 20 * scale),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(10 * scale, 20 * scale) // anchor
                            }
                        });
                        monuments.push(marker);
                    });
                });
                map.addListener('zoom_changed', () => {
                    let scaledSize;
                    let anchor;
                    let p = {
                        18: 160 * scale,
                        17: 80 * scale,
                        16: 40 * scale,
                        15: 20 * scale,
                        14: 10 * scale,
                        13: 5 * scale,
                        12: 1 * scale
                    };
                    scaledSize = new google.maps.Size(p[map.zoom], p[map.zoom]);
                    anchor = new google.maps.Point(p[map.zoom] / 2, p[map.zoom]);
                    for (var i = 0; i < monuments.length; i++) {
                        var icon = monuments[i].getIcon();
                        icon.scaledSize = scaledSize;
                        icon.anchor = anchor;
                        monuments[i].setIcon(icon);
                        // monuments[i].setMap(null);
                        // monuments[i].setMap(map);
                    }
                });
                $(map).trigger("zoom_changed");
                if (Cookies.get("currentCity")) {
                    let chosenCity = getCityBySlug(cities, Cookies.get("currentCity"));
                    if (chosenCity != null) {
                        map.setCenter(chosenCity.coords);
                    }
                }
            }
        });
        let previousIcon = null;
        let previousMarker = null;
        let markers = {};
        axios.post("/api/places", formData).then(function (response) {
            // handle success
            if (response.status == 200 && response.data.success == true) {
                let places = response.data.places;
                // a  div where we will place the buttons
                var placesCtrl = $('<div/>').addClass("places-controller shepperd-step").attr("id", "places-controller");
                let id = 1;
                //now loop over the categories
                $.each(places, function (c, category) {
                    //
                    let cluster = null;
                    let clusterOptions = null;
                    const renderer = {
                        render: ({ count, position }) => new google.maps.Marker({
                            label: { text: String(count), color: category.slug == "adv" ? "#FFF" : "#000", lineHeight: "12px", fontSize: "16px", fontWeight: "bold" },
                            position,
                            icon: category.cluster,
                            // adjust zIndex to be above other markers
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                        }),
                    };
                    markers[category.slug] = [];
                    id++;
                    //a checkbox fo the category
                    var cat = $('<input>', { type: 'checkbox' }).change(function (e) {
                        markers[category.slug].map((element) => {
                            element.setVisible(e.currentTarget.checked);
                        });
                        if (cluster != null) {
                            if (!e.currentTarget.checked) {
                                cluster.setMap(null);
                            }
                            else {
                                cluster = new MarkerClusterer(clusterOptions);
                            }
                        }
                        $(e.currentTarget).data('goo').set('map', (e.currentTarget.checked) ? map : null);
                    })
                        .addClass("category-checkbox")
                        //create a data-property with a google.maps.MVCObject
                        //this MVC-object will do all the show/hide for the category 
                        .data('goo', new google.maps.MVCObject)
                        .prop('checked', type == null ? !!category.checked : (category.slug == type))
                        .attr("id", "cat-" + id)
                        //this will initialize the map-property of the MVCObject
                        .trigger('change')
                        //label for the checkbox
                        .appendTo($('<div/>').addClass(`category scheme-${category.slug}`).appendTo(placesCtrl))
                        .after(`<label for='cat-${id}'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30.168" height="36.872" viewBox="0 0 30.168 36.872">
                            <path class="pointer" d="M34.668,16.584c0,11.732-15.084,21.788-15.084,21.788S4.5,28.316,4.5,16.584a15.084,15.084,0,0,1,30.168,0Z" transform="translate(-4.5 -1.5)" fill="#80de86"/>
                            <path d="M23.723,15.612A5.112,5.112,0,1,1,18.612,10.5,5.112,5.112,0,0,1,23.723,15.612Z" transform="translate(-3.528 -0.507)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        </svg>
                        <span>${category.label}</span>
                    </label>`);
                    //loop over the items(markers)
                    $.each(category.items, function (m, item) {
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(item.lat, item.lng),
                            title: item.name,
                            icon: category.icon,
                            selected: category.selectedIcon,
                            defaultIcon: category.icon,
                            zIndex: 100
                        });
                        //bind the map-property of the marker to the map-property
                        //of the MVCObject that has been stored as checkbox-data 
                        // marker.bindTo('map',cat.data('goo'),'map');
                        marker.setMap(map);
                        google.maps.event.addListener(marker, 'click', function () {
                            if (previousIcon != null) {
                                previousMarker.setIcon(previousIcon);
                            }
                            previousIcon = category.icon;
                            previousMarker = marker;
                            marker.setIcon(category.selectedIcon);
                            if (popupIsOpened) {
                                $(".map-popup").fadeOut(250, () => {
                                    $('.map-popup').remove();
                                    createPopup(category, item);
                                });
                            }
                            else {
                                createPopup(category, item);
                            }
                        });
                        // If 
                        if (directCoords != null && directCoords.lat == item.lat && directCoords.lng == item.lng) {
                            if (previousIcon != null) {
                                previousMarker.setIcon(previousIcon);
                            }
                            previousIcon = category.icon;
                            previousMarker = marker;
                            marker.setIcon(category.selectedIcon);
                        }
                        markers[category.slug].push(marker);
                    });
                    clusterOptions = { map: map, markers: markers[category.slug], renderer: renderer };
                    cluster = new MarkerClusterer(clusterOptions);
                    if (type != null && category.slug != type) {
                        markers[category.slug].map((element) => {
                            element.setVisible(false);
                        });
                        cluster.setMap(null);
                    }
                });
                //use the buttons-div as map-control 
                map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(placesCtrl[0]);
                if (directCoords != null) {
                    $("body").removeClass("hide-controls");
                    map.setCenter(directCoords);
                    if ($("#mapholder").attr("data-overview") === void 0) {
                        map.setZoom(18);
                    }
                }
                setTimeout(() => {
                    let language = $("#mapholder").attr("data-locale");
                    driver = new Driver({
                        doneBtnText: language == "fr" ? 'Finis' : "Afsluiten",
                        closeBtnText: language == "fr" ? 'Fermer' : "Sluiten",
                        nextBtnText: language == "fr" ? 'Suivant' : "Volgende",
                        prevBtnText: language == "fr" ? 'Précédent' : "Vorige",
                        opacity: 0,
                        onDeselected: () => {
                            Cookies.set("diver", "ok");
                        }
                    });
                    driver.defineSteps([
                        {
                            element: '#places-controller',
                            popover: {
                                title: language == "fr" ? 'Filtres' : "Filters",
                                description: language == "fr" ? 'Vous pouvez afficher ou masquer les réalisations artistiques dune catégorie en cliquant sur le nom de la catégorie.' : "U kunt de kunstwerken in een categorie tonen of verbergen door op de categorienaam te klikken.",
                                position: "top"
                            },
                        },
                        {
                            element: '.filter-ctrl',
                            popover: {
                                title: language == "fr" ? 'Changer de ville' : "Veranderende steden",
                                description: language == "fr" ? 'Vous pouvez changer de ville via ce bouton. ' : "U kunt de stad wijzigen via deze knop.",
                                position: "right"
                            }
                        },
                        {
                            element: '.geoloc-ctrl',
                            popover: {
                                title: language == "fr" ? 'Vous êtes perdu ?' : "Bent u verdwaald?",
                                description: language == "fr" ? 'Vous pouvez vous localiser sur la carte grâce à ce bouton.' : "Met deze knop kunt u jezelf op de kaart lokaliseren.",
                                position: "right"
                            }
                        },
                        {
                            element: '.menu',
                            popover: {
                                title: language == "fr" ? 'Changer de page' : "Pagina wijzigen",
                                description: language == "fr" ? 'Vous pouvez vous rendre sur la page de votre choix via ce menu.' : "Via dit menu kunt u naar de pagina van uw keuze gaan.",
                                position: "left"
                            }
                        },
                    ]);
                }, 1000);
            }
        });
        $("body").on("click", ".map-popup .close-popup", (e) => {
            e.preventDefault();
            if (previousIcon != null) {
                previousMarker.setIcon(previousIcon);
                previousIcon = null;
            }
            $(".map-popup").fadeOut(250, () => {
                $(".map-popup").remove();
                popupIsOpened = false;
            });
        });
        $("body").on("click", ".map-popup .content", (e) => {
            e.preventDefault();
            document.location = $('.map-popup').find(".link").attr("href");
        });
        $('.filter-ctrl > a').on("click", (e) => {
            e.preventDefault();
            $("#mapholder").toggleClass("show-quick-jump");
            setTimeout(() => {
                $("#mapholder").removeClass("error away");
            }, 2000);
        });
        $('.geoloc-ctrl > a').on("click", (e) => {
            e.preventDefault();
            directCoords = null;
            askGeolocation(map);
        });
        $("body").on("click", "#quick-jump a[href='#city']", (e) => {
            e.preventDefault();
            map.setCenter({
                lat: parseFloat($(e.currentTarget).attr("data-lat")),
                lng: parseFloat($(e.currentTarget).attr("data-lng"))
            });
            Cookies.set("currentCity", $(e.currentTarget).attr("data-slug"));
            $("#mapholder").removeClass("show-quick-jump");
            if (Cookies.get("diver") == null)
                driver.start();
            setTimeout(() => {
                $("#mapholder").removeClass("error away");
            }, 500);
        });
    })
        .catch(e => {
    });
    $("#introduction").on("click", "a[href='#explore']", (e) => {
        e.preventDefault();
        if (Cookies.get("currentCity") == null)
            askGeolocation(map);
        $("body").removeClass("hide-controls");
        Cookies.set("showintro", true);
    });
};
export default mapPage;
